import { createSlice } from "@reduxjs/toolkit";
import { set } from "lodash";

const bookingSlice = createSlice({
  name: "bookings",
  initialState: {
    bookings: null,
    LastBookingsFromAPI: null,
    bookingsFieldsEnabled: false,
    deleteAPis: [],
    isScheduledBooking: false,
    isTextSearch: false,
    isIrisSearch: false,
    irisSearchId: 0,
    irisEnrolleId: 0,
    manualBookingData: {
      isManualBooking: false,
    },
    showBookings: false,
    irisDeviceConnected: false, // Added to track iris device connection status
  },
  reducers: {
    setBookings: (state, action) => {
      state.bookings = { ...state?.bookings, ...action.payload };
    },
    setDeleteAPis: (state, action) => {
      state.deleteAPis = [...state?.deleteAPis, action.payload];
    },
    setDeleteAPIEmpty: (state) => {
      state.deleteAPis = [];
    },
    setBookingsNull: (state) => {
      state.bookings = null;
    },
    setLastBookingsFromAPI: (state, action) => {
      state.LastBookingsFromAPI = action.payload;
    },
    setBookingsFieldsEnabled: (state, action) => {
      state.bookingsFieldsEnabled = action.payload;
    },
    setIsScheduledBooking: (state, action) => {
      state.isScheduledBooking = action.payload;
    },
    setShowBookings: (state, action) => {
      state.showBookings = action.payload;
    },
    setManualBookingData: (state, action) => {
      state.manualBookingData = action.payload;
    },
    setIrisDeviceConnected: (state, action) => {
      state.irisDeviceConnected = action.payload;
    },
    setIsTextSearch: (state, action) => {
      state.isTextSearch = action.payload;
    },
    setIsIrisSearch: (state, action) => {
      state.isIrisSearch = action.payload;
    },
    setIrisSearchId: (state, action) => {
      state.irisSearchId = action.payload;
    },
    setIrisEnrolleId: (state, action) => {
      state.irisEnrolleId = action.payload;
    },
  },
});

export const {
  setBookings,
  setDeleteAPis,
  setBookingsNull,
  setDeleteAPIEmpty,
  setLastBookingsFromAPI,
  setBookingsFieldsEnabled,
  setIsScheduledBooking,
  setShowBookings,
  setManualBookingData,
  setIrisDeviceConnected,
  setIsTextSearch,
  setIsIrisSearch,
  setIrisSearchId,
  setIrisEnrolleId,
} = bookingSlice.actions;
export default bookingSlice.reducer;
